import Vue from 'vue'
import '../utils/main.scss'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

//font awesome
import { library, dom, config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false
dom.watch()

import {
  faStar as fasStar,
  faExclamationTriangle as fasExclamationTriangle,
  faCheckCircle as fasCheckCircle,
  faTrash as fasTrash,
  faEdit as fasEdit,
  faChevronCircleDown as fasChevronCircleDown,
  faCheck as fasCheck,
  faTimes as fasTimes,
  faFileAlt as fasFileAlt,
  faTasks as fasTasks,
  faChartBar as fasChartBar,
  faCogs as fasCogs,
  faCog as fasCog,
  faUser as fasUser,
  faPlus as fasPlus,
  faEllipsisV as fasEllipsisV,
  faSearch as fasSearch,
  faQuestionCircle as fasQuestionCircle,
  faBug as fasBug,
  faDownload as fasDownload,
  faUpload as fasUpload,
  faFilter as fasFilter,
  faUniversity as fasUniversity,
  faCube as fasCube,
  faMoneyCheck as fasMoneyCheck,
  faList as fasList,
  faChartPie as fasChartPie,
  faCloudUpload as fasCloudUpload,
  faInfoCircle as fasInfoCircle,
  faLongArrowRight as fasLongArrowRight,
  faSyncAlt as fasSyncAlt,
  faColumns as fasColumns,
  faChevronLeft as fasChevronLeft,
  faArchive as fasArchive,
  faArrowToRight as fasArrowToRightPro,
  faInfoCircle as fasInfoCirclePro,
  faHeadset as faHeadsetPro,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faStar as farStar,
  faTimesCircle as farTimesCircle,
  faCheckCircle as farCheckCircle,
  faEye as farEye,
  faBellSlash as farBellSlash,
  faInfoCircle as farInfoCircle,
  faQuestionCircle as farQuestionCircle,
  faChevronDown as farChevronDown,
  faChevronUp as farChevronUp,
  faLayerGroup as farLayerGroup,
  faLightbulb as farLightbulb,
  faArrowDown as farArrowDown,
  faArrowUp as farArrowUp,
  faFileSearch as farFileSearch,
} from '@fortawesome/pro-regular-svg-icons'

import { faGripVertical as falGripVerticalPro } from '@fortawesome/pro-light-svg-icons'

// Add every icon used in the app
library.add(
  // far
  farTimesCircle,
  farStar,
  farCheckCircle,
  farEye,
  farBellSlash,
  farInfoCircle,
  farQuestionCircle,
  farChevronDown,
  farChevronUp,
  farLayerGroup,
  farLightbulb,
  farArrowDown,
  farArrowUp,
  farFileSearch,

  // fas
  fasStar,
  fasExclamationTriangle,
  fasCheckCircle,
  fasTrash,
  fasEdit,
  fasChevronCircleDown,
  fasCheck,
  fasTimes,
  fasFileAlt,
  fasTasks,
  fasChartBar,
  fasCogs,
  fasCog,
  fasUser,
  fasPlus,
  fasEllipsisV,
  fasSearch,
  fasQuestionCircle,
  fasBug,
  fasDownload,
  fasUpload,
  fasFilter,
  fasUniversity,
  fasCube,
  fasMoneyCheck,
  fasList,
  fasChartPie,
  fasCloudUpload,
  fasInfoCircle,
  fasChevronLeft,
  fasLongArrowRight,
  fasSyncAlt,
  fasColumns,
  fasArchive,
  falGripVerticalPro,
  fasArrowToRightPro,
  fasInfoCirclePro,
  faHeadsetPro
)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)
